import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TypeSelection } from '@components/type-selector/1.0/index';
import { NgFor, NgClass, NgIf } from '@angular/common';

@Component({
  selector: 'txp-type-selector',
  templateUrl: './type-selector.component.html',
  styleUrls: ['./type-selector.component.scss'],
  standalone: true,
  imports: [NgFor, NgClass, NgIf],
})
export class TypeSelectorComponent {
  @Input() types: TypeSelection[];
  @Input() selected: any;
  @Input() disabled: boolean;
  @Input() columns: number = 2;

  // TODO: http://codelyzer.com/rules/no-output-named-after-standard-event/
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() select = new EventEmitter<any>();

  onSelect(data: any) {
    this.select.emit(data);
  }
}
